import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'safeDate',
})
export class SafeDatePipe implements PipeTransform {
  transform(value: any, format: 'iso' | 'timestamp' | 'local' = 'iso'): string {
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';

    switch (format) {
      case 'timestamp':
        return date.getTime().toString();
      case 'local':
        return date.toLocaleString();
      case 'iso':
      default:
        return date.toISOString();
    }
  }
}
